// extracted by mini-css-extract-plugin
export default {"root":"Contact_root__08PNC","title":"Contact_title__lTnZo"};